// BUILD-046 pass F1 (Owner direction 2026-10-25, item 2): "Requested by <name> on <date>" in the header of Edit task and Update task - the ORIGINAL requester, whichever tab opened the form and whatever the
// list's "Show requester" display setting says. What it shows comes from requesterContextModel.ts (the task's own requester and recorded request date); nothing is shown when the task carries none.
import { PersonName } from './PersonName';
import { requesterContext } from './requesterContextModel';

export function RequestedBy({ item, testId }: { item: unknown; testId: string }) {
  const context = requesterContext(item);
  if (context === null) return null;
  return (
    <p className="text-xs text-gray-600" data-testid={testId}>
      Requested by{' '}
      <span className="font-medium text-gray-800">
        <PersonName person={context.name} />
      </span>
      {context.requestedOn !== '' ? <span> on {context.requestedOn}</span> : null}
    </p>
  );
}
